import api from "../../api/api";

class GlobalService {
    async getStatus() {
        const res = await api().get(`competition/status`)
        return res
    }

    async getList() {
        const res = await api().get(`competition/competitions`)
        return res
    }

    async chooseSelect(id) {
        return await api().get(`competition/select/${id}`)
    }
}

export default new GlobalService()
